// extracted by mini-css-extract-plugin
export default {"button":"S7q9n3BKNuH4Mxybl4AN","disabled":"Z62u6WHv7flPQv1KOI_H"};